import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class storageUtil {
    public getLoggedInUser() {
        return localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser') as any) : null;
    }

    public setLoggedInUser(loggedInUser: string) {
        return localStorage.setItem('loggedInUser', JSON.stringify(loggedInUser));
    }

    public removeLoggedInUser() {
        localStorage.removeItem('loggedInUser');
    }

    public setItem(data: any, key: string) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    public getItem(key: string) {
        return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) as any) : null;
    }

    public clearItem(key: string) {
        return localStorage.removeItem(key)
    }

    public clearStorage() {
        localStorage.clear();
    }

    public base64ToBlob(base64: any) {
        const byteArray = new Uint8Array(atob(base64).split('').map(char => char.charCodeAt(0)));
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    public parseNumber(number: any) : number {
        return number ? parseInt(number) : 0;
    }
}